import { render } from "./editReserveComponent.vue?vue&type=template&id=5c8938aa"
import script from "./editReserveComponent.vue?vue&type=script&lang=js"
export * from "./editReserveComponent.vue?vue&type=script&lang=js"

import "./editReserveComponent.vue?vue&type=style&index=0&id=5c8938aa&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/r2-disponibilidade-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__